// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const spritzee: PokeData = {
  "id": 682,
  "name": "spritzee",
  "height": 2,
  "weight": 5,
  "base_experience": 68,
  "types": [
    PokeType.FAIRY
  ],
  "api_moves": [
    "psychic",
    "flail",
    "sweet-kiss",
    "charm",
    "attract",
    "sweet-scent",
    "skill-swap",
    "aromatherapy",
    "odor-sleuth",
    "calm-mind",
    "echoed-voice",
    "disarming-voice",
    "draining-kiss",
    "misty-terrain",
    "fairy-wind",
    "moonblast"
  ],
  "moves": [
    "psychic",
    "sweet-kiss",
    "aromatherapy",
    "calm-mind",
    "misty-terrain",
    "moonblast",
    "guardian-bond",
    "dazzling-gleam",
    "spirit-break",
    "starfall",
    "mist-terrain",
    "heal-bell",
    "moonlight"
  ],
  "evolution_chain": {
    "id": 350,
    "item": null,
    "species": [
      {
        "name": "spritzee",
        "order": 683,
        "types": [
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "aromatisse",
        "order": 684,
        "types": [
          PokeType.FAIRY
        ],
        "evolves_from_species_id": 682,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 70.25,
    "speed": 23,
    "ability_power": 63
  },
  "stat_changes": [],
  "catch_rate": 200,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
